export type FingerType =
  | "left_four_fingers"
  | "left_thumb"
  | "left_index"
  | "left_middle"
  | "left_ring"
  | "left_little"
  | "right_four_fingers"
  | "right_thumb"
  | "right_index"
  | "right_middle"
  | "right_ring"
  | "right_little"
  | "unspecified";

export type GuidanceCode =
  | "STARTING_CAMERA"
  | "PLACE_FINGER"
  | "MOVE_CLOSER"
  | "MOVE_BACK"
  | "CENTER_FINGER"
  | "HOLD_STILL"
  | "TOO_DARK"
  | "TOO_BRIGHT"
  | "REDUCE_GLARE"
  | "IMAGE_BLURRY"
  | "RIDGES_NOT_VISIBLE"
  | "READY"
  | "CAPTURING"
  | "ENHANCING";

export type FingerprintErrorCode =
  | "PERMISSION_DENIED"
  | "CAMERA_UNAVAILABLE"
  | "UNSUPPORTED_DEVICE"
  | "QUALITY_TIMEOUT"
  | "CAPTURE_CANCELLED"
  | "PROCESSING_FAILED"
  | "INSECURE_CONTEXT";

export interface CaptureTheme {
  accentColor?: string;
  backgroundColor?: string;
  textColor?: string;
  mutedColor?: string;
}

export interface CaptureMessages {
  title?: string;
  subtitle?: string;
  cancel?: string;
  startingCamera?: string;
  placeFinger?: string;
  moveCloser?: string;
  moveBack?: string;
  centerFinger?: string;
  holdStill?: string;
  tooDark?: string;
  tooBright?: string;
  reduceGlare?: string;
  imageBlurry?: string;
  ridgesNotVisible?: string;
  ready?: string;
  capturing?: string;
  enhancing?: string;
}

/**
 * Public capture options. Quality thresholds intentionally remain private so
 * consumers cannot accidentally weaken the acceptance policy.
 */
export interface FingerprintCaptureOptions {
  finger?: FingerType;
  debug?: boolean;
  timeoutMs?: number;
  stableDurationMs?: number;
  burstFrames?: number;
  cameraFacing?: "environment" | "user";
  theme?: CaptureTheme;
  messages?: CaptureMessages;
  signal?: AbortSignal;
  onGuidance?: (code: GuidanceCode) => void;
}

export interface CaptureProgress {
  guidance: GuidanceCode;
  stableProgress: number;
}

export class FingerprintCaptureError extends Error {
  readonly code: FingerprintErrorCode;
  readonly retryable: boolean;

  constructor(
    code: FingerprintErrorCode,
    message: string,
    retryable = true,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "FingerprintCaptureError";
    this.code = code;
    this.retryable = retryable;
  }
}
